import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import { DecimalNumber, SubmissionScore } from '@module/assignment';
import styled from '@xstyled/styled-components';
import { Space, Input, Row, Col, Tooltip } from 'antd';
import { styleVariables } from '@lib/common';
import { GradingAnswer } from './base-answer.component';
import { ScoreInputNumber } from '../score-input';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledSpace = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledAnswerContainer = styled(Col)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var StyledQuestionIndex = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  text-align: center;\n  margin-right: ", ";\n"])), styleVariables.margin.medium);
var StyledInput = styled(Input)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  cursor: not-allowed;\n  width: 93%;\n  padding: ", ";\n  border: ", ";\n  border-radius: ", ";\n"])), function (props) {
  return props.theme.color.fontColorDefault;
}, styleVariables.font.fontSizeSmall, styleVariables.padding.small, function (props) {
  return "".concat(styleVariables.borderWidth.small, " solid ").concat(props.theme.color.borderDefault);
}, styleVariables.borderRadius.small);
var StyledRow = styled(Row)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n"])));
var StyledCorrectAnswerText = styled.label(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: ", ";\n  margin-left: 12px;\n"])), function (props) {
  return props.$error ? props.theme.color.fontColorError : props.theme.color.fontColorSuccess;
}, styleVariables.font.fontWeightStrong);
export var GradingFillInBlank = function GradingFillInBlank(_ref) {
  var question = _ref.question,
      answerGroup = _ref.answerGroup,
      label = _ref.label,
      onGradeAnswer = _ref.onGradeAnswer,
      updatedBlankId = _ref.updatedBlankId,
      disabled = _ref.disabled,
      isOnGradingProcess = _ref.isOnGradingProcess;
  var isAllSubQuestionNotGraded = answerGroup.answers.every(function (answeredSubQuestion) {
    return !answeredSubQuestion.hasGraded();
  });
  var totalScore = isAllSubQuestionNotGraded ? null : answerGroup.answers.reduce(function (sum, answer) {
    if (!answer.hasGraded()) {
      return sum;
    }

    return DecimalNumber.roundNumber(sum + answer.score);
  }, 0);

  var renderAnswers = function renderAnswers() {
    return question.answers.map(function (questionAnswer, index) {
      var _answer$value;

      var answer = answerGroup === null || answerGroup === void 0 ? void 0 : answerGroup.answers.find(function (a) {
        return a.answerBlankId === questionAnswer.id.toString();
      });
      var correctAnswer = question.correctAnswers.find(function (a) {
        return a.answerId === questionAnswer.id.toString();
      });
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(StyledRow, {
          children: [/*#__PURE__*/_jsxs(StyledAnswerContainer, {
            span: 19,
            children: [/*#__PURE__*/_jsxs(StyledQuestionIndex, {
              children: ["(", index + question.index, ")"]
            }), /*#__PURE__*/_jsx(StyledInput, {
              size: "large",
              readOnly: true,
              value: answer === null || answer === void 0 ? void 0 : (_answer$value = answer.value) === null || _answer$value === void 0 ? void 0 : _answer$value.text
            }), /*#__PURE__*/_jsxs(StyledCorrectAnswerText, {
              $error: correctAnswer.score !== answer.score,
              children: ["(", correctAnswer.score === answer.score ? label.correct : label.incorrect, ")"]
            })]
          }), correctAnswer !== null && correctAnswer !== void 0 && correctAnswer.score ? /*#__PURE__*/_jsx(Tooltip, {
            title: disabled ? label.disabledScoreInputText : '',
            children: /*#__PURE__*/_jsx(ScoreInputNumber, {
              label: {
                score: label.score
              },
              min: 0,
              max: correctAnswer === null || correctAnswer === void 0 ? void 0 : correctAnswer.score,
              score: answer.score !== SubmissionScore["default"].value ? answer.score : null,
              onGradedScore: function onGradedScore(score) {
                return onGradeAnswer === null || onGradeAnswer === void 0 ? void 0 : onGradeAnswer(score, answer.id.toString());
              },
              disabled: updatedBlankId === answer.id.toString() || disabled || isOnGradingProcess
            })
          }) : null]
        }, questionAnswer.id.toString()), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            span: 24,
            children: /*#__PURE__*/_jsxs(StyledCorrectAnswerText, {
              $error: false,
              children: ["(", label.correctAnswers, ": ", questionAnswer.description, ")"]
            })
          })
        })]
      });
    });
  };

  return /*#__PURE__*/_jsx(GradingAnswer, {
    label: label,
    question: question,
    disabled: true,
    score: totalScore,
    children: /*#__PURE__*/_jsx(StyledSpace, {
      direction: "vertical",
      size: "middle",
      children: renderAnswers()
    })
  });
};